import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface SendDraftDistributionPayload {
  distributionId: string;
  skipAvailabilityCheck?: boolean;
}

export const sendDraftDistributionApi = createAsyncThunk(
  'hl7/sendDraftDistribution',
  async (payload: SendDraftDistributionPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const { distributionId, skipAvailabilityCheck } = payload;
      const body =
        skipAvailabilityCheck !== undefined ? JSON.stringify({ skipAvailabilityCheck }) : undefined;
      const response = await fetch(HL7.SEND_DRAFT(distributionId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: body ?? JSON.stringify({}),
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Send draft failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
